module.exports = __webpack_public_path__ + "img/publishers.cb11657f.png";